import * as React from 'react';
import './style.css';

export interface FooterCreditsProps {
  /* empty */
}

export interface FooterCreditsState {
  /* empty */
}

export class FooterCredits extends React.Component<
  FooterCreditsProps,
  FooterCreditsState
> {
  render() {
    const currentYear = new Date().getFullYear();
    const edgeOfPlayCompanyNumber = `11036449`;
    // A JSX-equivalent of old-school &nbsp; - to get the spacing right
    // after newlines
    const separator = <span className="footer-separator">|</span>;

    return (
      <div className="footer-credits">
        <a
          href="http://adamdoddphotography.co.uk/"
          className="edge-of-play-link footer-credits-link"
        >
          Photography Credit: Adam Dodd
        </a>
        {separator}
        <a
          href="https://buildempire.co.uk"
          className="edge-of-play-link footer-credits-link"
        >
          Website built by BuildEmpire
        </a>
        <br />
        © Edge of Play {currentYear}
        {separator}
        Company Registration No. {edgeOfPlayCompanyNumber}
      </div>
    );
  }
}

export default FooterCredits;



// WEBPACK FOOTER //
// ./src/app/components/App/Footer/FooterCredits/index.tsx